import { FC } from 'react'

import { IconName, IconV2 } from 'ui/components/Icon'

import { s } from './styles'

export const SearchButton: FC<{ onClick: () => void }> = ({ onClick }) => (
  <s.SearchButton onClick={onClick} data-testid="global-search-button">
    <IconV2 name={IconName.SEARCH} />
    <span>Search ...</span>
    <IconV2 name={IconName.FORWARD_SLASH} />
  </s.SearchButton>
)
